import React, { useState, useEffect, useContext } from 'react';

import ImageHeader from "../../../components/reunioes/reunioesImageHeader";
import AbaSobre from "../../../components/reunioes/visualizar/abas/sobre";
import AbaConvidados from "../../../components/reunioes/visualizar/abas/convidados";
import AbaDocumentos from "../../../components/reunioes/visualizar/abas/documentos";
import AbaFormulario from "../../../components/reunioes/visualizar/abas/formulario";
import AbaPauta from "../../../components/reunioes/visualizar/abas/pauta";
import AbaFotos from "../../../components/reunioes/visualizar/abas/fotos";
import {getById, getConvidados} from '../../../services/reuniao/ReuniaoService';


const VisualizarReuniao = (props) => {

  const [ativo, setAtivo] = useState(0);
  const [qtdConvidados, setQtdConvidados] = useState(0);

  const id = props.match.params.id;

  const { history } = props;

  const initialStateDados =
    {
      id:'',
      idConselho:'',
      descricaoConselho:'',
      edicao:'',
      periodicidade:'',
      data:'',
      descricao:'',
      cep:'',
      estado:'',
      cidade:'',
      endereco:'',
      pauta:'',
      pautaExtra:'',
      ata:'',
      dataConvocacao:'',
      formulario: {
        id: null,
        nome: null,
        // status: null,
        dataInicio: null,
        dataLimite: null,
        // preenchimentos: []
      }
    }

  const [dados, setDados] = useState(initialStateDados);  

  useEffect(() => {
    getById(id).then((response) => {
      if (response && response.status === 200) {
        const { data } = response;        
        setDados((prevDados) => ({
            ...prevDados,
            ...data
          }))
        getConvidados(data.id).then((response) => {
          if (response && response.status === 200) {
            const { data } = response;
            setQtdConvidados(data.length)
          }
        });
      } else {
        history.push('/reunioes');
      }
    });

  }, [])

  const defineAba = (num) => {
    switch (num) {
      case 0:
        return <AbaSobre id={id} />;
      case 1:
        return <AbaPauta id={id} />;
      case 2:
        return <AbaDocumentos dados={dados} />;
      case 3:
        return <AbaConvidados dados={dados} setQtdConvidados={setQtdConvidados}/>;
      case 4:
        return <AbaFormulario dados={dados} updateDados={setDados} />;
      case 5:
        return <AbaFotos id={id} dados={dados} />;
    }
  }

  const reuniaoPassada = (dia) => {
    if (!dia) {
      return true;
    }

    let hoje = new Date();
    let diaReuniao = new Date(dia);
    return hoje.getTime() - diaReuniao.getTime() >= 0;
  }

  const opcoes = reuniaoPassada(dados.data) ? ["Sobre", "Pauta e Ata", "Documentos", "Convidados","Formulário", "Mídias"] : ["Sobre", "Pauta e Ata", "Documentos", "Convidados", "Formulário"];

  return (
    <>
      <ImageHeader history={history} idReuniao={id} edicao={dados.edicao} reuniaoPassada={reuniaoPassada(dados.data)} periodicidade={dados.periodicidade} opcoes={opcoes} ativo={ativo} setAtivo={setAtivo}
        conselho={dados.descdescricaoConselhoConselho} qtdConvidados={qtdConvidados} dataConvocacao={dados.dataConvocacao}/>
      <div style={{ padding: 24 }}>
        {defineAba(ativo)}
      </div>
    </>
  );
}

export default VisualizarReuniao;
